import { useMemo } from "react";
import type { AdProviderConfig } from "./types";

type AdConfigEnv = {
  publisherId?: string;
  enabled?: boolean | string;
  testMode?: boolean | string;
};

/**
 * 環境変数から広告設定を構築するフック
 *
 * @example
 * ```tsx
 * const adConfig = useAdConfig({
 *   publisherId: import.meta.env.VITE_ADSENSE_PUBLISHER_ID,
 *   enabled: import.meta.env.VITE_ADS_ENABLED,
 *   testMode: import.meta.env.VITE_ADS_TEST_MODE,
 * });
 *
 * return (
 *   <AdProvider config={adConfig}>
 *     <App />
 *   </AdProvider>
 * );
 * ```
 */
export function useAdConfig(env: AdConfigEnv): AdProviderConfig {
  return useMemo(() => {
    const parseBoolean = (value: boolean | string | undefined, defaultValue: boolean): boolean => {
      if (typeof value === "boolean") return value;
      if (typeof value === "string") return value === "true";
      return defaultValue;
    };

    return {
      publisherId: env.publisherId ?? "",
      enabled: parseBoolean(env.enabled, false),
      testMode: parseBoolean(env.testMode, false),
    };
  }, [env.publisherId, env.enabled, env.testMode]);
}
